module.exports = __webpack_public_path__ + "static/media/usb-c-gold.a13df84b.svg";